import { useMemo } from 'react'

import {
  ResponseAvgCycleTime,
  ResponseCommentDensity,
  ResponseLateDeliverables,
} from '@/schema'

import {
  useGetAvgCycleTime,
  useGetCommentDensity,
  useGetLateDeliverables,
} from './index'
import { useProjectLevelShared } from './useProjectLevelShared'

type TUseProjectLevelMetricResult = {
  lateDeliverablesMetric: ResponseLateDeliverables
  commentDensityMetric: ResponseCommentDensity
  avgCycleTimeMetric: ResponseAvgCycleTime
  isLoadingLateDeliverables: boolean
  isLoadingCommentDensity: boolean
  isLoadingAvgCycleTime: boolean
}

export const useProjectLevelMetric = (): TUseProjectLevelMetricResult => {
  const { queryOptions, analyticsParams, projectParams } =
    useProjectLevelShared()

  const {
    data: { data: [lateDeliverablesMetric] = [] } = {},
    isLoading: isLoadingLateDeliverables,
  } = useGetLateDeliverables(analyticsParams, queryOptions)

  const {
    data: { data: [commentDensityMetric] = [] } = {},
    isLoading: isLoadingCommentDensity,
  } = useGetCommentDensity(
    {
      ...analyticsParams,
      deliverable_set_id: undefined,
    },
    queryOptions
  )

  const {
    data: { data: [avgCycleTimeMetric] = [] } = {},
    isLoading: isLoadingAvgCycleTime,
  } = useGetAvgCycleTime(projectParams, queryOptions)

  return useMemo(
    () => ({
      lateDeliverablesMetric,
      isLoadingLateDeliverables,
      commentDensityMetric,
      isLoadingCommentDensity,
      avgCycleTimeMetric,
      isLoadingAvgCycleTime,
    }),
    [
      lateDeliverablesMetric,
      isLoadingLateDeliverables,
      commentDensityMetric,
      isLoadingCommentDensity,
      avgCycleTimeMetric,
      isLoadingAvgCycleTime,
    ]
  )
}
